export default __webpack_public_path__ + "static/media/armadillo-pipe-guard.88a0b54b.jpg";